module.exports = __webpack_public_path__ + "img/ab44913eabddf942b87182e31e15b5d1c750b2a4.bc63c6c8.png";